/**
 * Frontend version — bump on every feature/hotfix branch so atlas-tracked
 * deploys show the correct shipped version.
 */
export const VERSION = '0.3.0';
